import React, { useState, useEffect } from 'react';
import { NewsList } from './UI/NewsList';
import styled from 'styled-components';
import { useLocation, useHistory } from 'react-router-dom';

import useConfigs from '../hooks/useConfigs';
import useThemes from '../hooks/useThemes';

// ##### Estilos #####
const ContTemplatePost = styled.div`
  width: 100%;
  background-color: ${(props) => props.background};

  h1 {
    color: ${(props) => props.colorsecundario};
    font-size: ${(props) => 55 * props.fontsizemultiplier};
    margin-bottom: 4rem;
  }

  h2 {
    color: ${(props) => props.colorprincipal};
    font-size: ${(props) => 35 * props.fontsizemultiplier};
  }

  h3 {
    color: ${(props) => props.colorprincipal};
    font-size: ${(props) => 28 * props.fontsizemultiplier};
  }

  p {
    color: ${(props) => props.colortipografia};
    font-size: ${(props) => 14 * props.fontsizemultiplier};
  }
`;

const ContImgPostNews = styled.div`
  /* outline: 1px solid red;
  max-height: 410px; */

  img {
    border-radius: 25px;
    width: 100%;
    background-size: cover;
  }

  p {
    border-left: 1rem solid var(--azul-verde);
    color: ${(props) => props.color};
    font-weight: bold;
    width: 100%;
    margin-top: 1rem;
    padding: 1rem 2rem;
    box-sizing: border-box;
    font-size: ${(props) => 12 * props.fontsizemultiplier};
  }
`;

const TextoDestacadoPostNews = styled.div`
  p {
    font-size: ${(props) => 25 * props.fontsizemultiplier} !important;
    font-weight: bold;
    color: ${(props) => props.color};
  }
`;

const ContCardColumnasPost = styled.div`
  width: 100%;
  cursor: pointer;

  img {
    width: 100%;
    border-radius: 3rem;
  }

  h3 {
    color: ${(props) => props.color};
    font-weight: bold;
    font-size: ${(props) => 22 * props.fontsizemultiplier};
  }

  p {
    color: ${(props) => props.colortipografia};
    font-size: ${(props) => 14 * props.fontsizemultiplier};
  }
`;

const New4 = styled.div`
  width: 100%;

  img {
    width: 100%;
    border-radius: 3rem;
  }

  .link {
    color: ${(props) => props.color};
    font-weight: bold;
    font-size: ${(props) => 16 * props.fontsizemultiplier};
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

const ContAsidePostTemplate = styled.div`
  h3 {
    color: ${(props) => props.colorprincipal};
    font-weight: bold;
    font-size: ${(props) => 16 * props.fontsizemultiplier};
  }

  hr {
    width: 100%;
    background-color: ${(props) => props.colorsecundario};
    height: 3px;
  }
`;

const BtnCompartirArticulo = styled.div`
  background-color: transparent;
  color: ${(props) => props.colorsecundario};
  border: 2px solid ${(props) => props.colorprincipal};
  padding: 1rem 10rem;
  border-radius: 100px;
  font-weight: bold;
  cursor: pointer;
  font-size: ${(props) => 14 * props.fontsizemultiplier};

  &:hover {
    background-color: ${(props) => props.colorprincipal};
    color: ${(props) => props.colortercero};
  }
`;

export const PageTemplatePostNews = () => {
  window.scroll(0, 0)
  const { fontSizeMultiplier } = useConfigs();
  const { state } = useLocation();
  const {
    backgroundWhite,
    backgroundOctavo,
    colorPrincipal,
    colorSecundario,
    colorCuarto,
  } = useThemes();
  const history = useHistory();

  const [noticias, setNoticias] = useState([]);
  const [noticia, setNoticia] = useState({});

  useEffect(() => {
    if (!state?.noticia) return;

    if (
      Object.entries(state?.noticia).length !== 0 &&
      state?.noticias.length !== 0
    ) {
      setNoticia(state.noticia);
      setNoticias(state.noticias);
    }
  }, [state?.noticia, state?.noticias]);

  return (
    <ContTemplatePost
      background={backgroundWhite}
      colorprincipal={colorPrincipal}
      colorsecundario={colorSecundario}
      colortipografia={colorCuarto}
      fontsizemultiplier={fontSizeMultiplier}
    >
      <header className='header-page'>
        <div
          className='headerPostTemplate'
          style={{
            background: `url(${noticia.imagen}) center center no-repeat`,
            backgroundSize: 'cover',
          }}
        >
          <div className='overlay'></div>
        </div>
      </header>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <h1>{noticia.titulo}</h1>
          </div>
          <div className='col-md-8'>
            <h2>{noticia.encabezado}</h2>

            <h3>{noticia.subtitulo}</h3>

            <p>{noticia.contenido}</p>
            <ContImgPostNews
              fontsizemultiplier={fontSizeMultiplier}
              color={colorPrincipal}
            >
              {noticia.imagen ? (
                <img src={noticia.imagen} alt={noticia.titulo} />
              ) : (
                <p className='NoIMG'> No hay imagen disponible </p>
              )}
              <p>{noticia.subtitulo}</p>
            </ContImgPostNews>

            <TextoDestacadoPostNews
              fontsizemultiplier={fontSizeMultiplier}
              color={colorCuarto}
            >
              <p>{noticia.encabezado}</p>
            </TextoDestacadoPostNews>
            <div className='columnas-post-news row mt-5'>
              {noticias
                .filter((item) => item.id !== noticia.id)
                .slice(0, 3)
                .map((item) => (
                  <ContCardColumnasPost
                    onClick={() =>
                      history.push({
                        pathname: '/unanoticia',
                        state: { noticia: item, noticias: noticias },
                      })
                    }
                    key={item.id}
                    fontsizemultiplier={fontSizeMultiplier}
                    color={colorPrincipal}
                    colortipografia={colorCuarto}
                    className='col mx-1'
                  >
                    <div>
                      {item.imagen !== '' ? (
                        <img src={item.imagen} alt={item.titulo} />
                      ) : (
                        <p className='NoIMG'> No hay imagen disponible </p>
                      )}
                      <h3>{item.titulo}</h3>
                      <p> {item.subtitulo} </p>
                      {/* <a href={d.urlBton}> */}
                    </div>
                  </ContCardColumnasPost>
                ))}
            </div>

            {noticias
              .filter((item) => item.id !== noticia.id)
              .slice(3, 4)
              .map((d) => (
                <New4
                  key={d.id}
                  fontsizemultiplier={fontSizeMultiplier}
                  color={colorSecundario}
                  className='row mt-5'
                >
                  <div className='col'>
                    {d.imagen ? (
                      <img src={d.imagen} alt={d.titulo} />
                    ) : (
                      <p className='NoIMG'> No hay imagen disponible </p>
                    )}
                  </div>
                  <ContCardColumnasPost
                    onClick={() =>
                      history.push({
                        pathname: '/unanoticia',
                        state: { noticia: d, noticias: noticias },
                      })
                    }
                    fontsizemultiplier={fontSizeMultiplier}
                    className='col'
                  >
                    <h3>{d.titulo}</h3>
                    <p> {d.subtitulo} </p>
                    {/* <p className="link">Link</p> */}
                  </ContCardColumnasPost>
                </New4>
              ))}
          </div>
          <ContAsidePostTemplate
            fontsizemultiplier={fontSizeMultiplier}
            colorprincipal={colorPrincipal}
            colorsecundario={backgroundOctavo}
            className='col-md-4 mt-5'
          >
            <BtnCompartirArticulo
              fontsizemultiplier={fontSizeMultiplier}
              colortercero={backgroundWhite}
              colorprincipal={colorPrincipal}
              colorsecundario={colorSecundario}
              onClick={() => {
                if (noticia.link) {
                  window.open(noticia.link);
                }
              }}
            >
              Compartir artículo
            </BtnCompartirArticulo>
            <h3>TE PUEDE INTERESAR</h3>
            <hr />
            <NewsList data={noticias} id={noticia.id} />
          </ContAsidePostTemplate>
        </div>
      </div>
    </ContTemplatePost>
  );
};
